import { HttpRequest } from '../../utils';
import { BulkResult } from './bulk-result';

export class BulkSuccess extends BulkResult {
    constructor(request: HttpRequest, status: number) {
        super();
        this.request = request;
        this.status = status;
        this.isError = false;
        this.isSuccess = true;
        this.isRecoverable = true;
    }
}
